export default __webpack_public_path__ + "static/media/Basket.a10c2125.svg";